import _ from 'lodash';
import { createSelector } from 'reselect';

import { selectRoles } from 'store/global/selectors';

import { getCompany } from './company.selectors';

const selectEmailSnippets = createSelector(
  getCompany,
  ({ emailSnippets }) => emailSnippets.snippets,
);

export const selectActiveEmailSnippet = createSelector(
  getCompany,
  ({ emailSnippets }) => emailSnippets.activeSnippet,
);

const selectEmailSnippetsList = createSelector(selectEmailSnippets, Object.values);

export const selectEmailSnippetsSortedList = createSelector(
  selectEmailSnippetsList,
  selectRoles,
  (snippets, securityGroups) => {
    const snippetsWithGroupName = snippets.map(snippet => ({
      ...snippet,
      securityGroupAssociation: {
        ...snippet.securityGroupAssociation,
        name:
          securityGroups[snippet.securityGroupAssociation?.securityGroupId]?.name || 'All Users',
      },
    }));

    return _.orderBy(snippetsWithGroupName, [
      item => _.toLower(item.securityGroupAssociation.name),
      item => _.toLower(item.name),
    ]);
  },
);

export const selectSnippetsBySecurityGroup = createSelector(
  selectEmailSnippetsSortedList,
  snippets => _.groupBy(snippets, 'securityGroupAssociation.securityGroupId'),
);
